import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { AppModule } from '@blade/common/store/app';
function createDialog(component, data) {
    // const component: any = Vue.extend(require<{
    //   default: any
    // }>(`@blade-sxp/tools/components/${fileName}`).default);
    return new Promise(function (resolve, reject) {
        const i18n = new VueI18n({
            locale: localStorage.getItem('language') || AppModule.language,
            messages: {
                en: {
                    face: 'Face selection',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    title: 'Face Detection',
                    description: 'Automatically cropped image to fit size',
                    portrait: 'Select portrait',
                    name: 'Name',
                    id: 'ID',
                    avatar: 'Avatar',
                    library: 'Portrait library',
                    operation: 'Operation',
                    select: 'Select',
                    reset: 'Reset',
                    search: 'Search',
                    selectLibrary: 'Select portrait library',
                    detail: 'Detail',
                    back: 'Back',
                    pre: 'Last',
                    next: 'Next',
                    source: 'Source: Local upload',
                    invalidddd: 'The portrait has expired and will not participate in control and retrieval operations, and the system will automatically delete relevant data after 7 days',
                },
                zh: {
                    face: '人脸选定',
                    cancel: '取消',
                    confirm: '确定',
                    title: '人脸检索',
                    description: '已自动截取适应尺寸的图像',
                    portrait: '选择人像',
                    name: '姓名',
                    id: 'ID',
                    avatar: '证件头像',
                    library: '人像库',
                    operation: '操作',
                    select: '选择',
                    reset: '清空',
                    search: '搜索',
                    selectLibrary: '选择人像库',
                    detail: '详情',
                    back: '返回',
                    pre: '上一张',
                    next: '下一张',
                    source: '来源：本地上传',
                    invalidddd: '人像已经过期，不参与布控、检索等操作，7天后系统自动删除相关数据。',
                }
            }
        });
        const DialogC = Vue.extend(component);
        const dialog = new DialogC({ data: () => data, i18n: i18n });
        const _onClose = dialog.$options?.methods?._onClose;
        dialog.onClose = function () {
            try {
                resolve('');
                dialog.$destroy();
                _onClose && _onClose.call(dialog);
                document.body.removeChild(dialog.$el);
            }
            catch (e) {
                reject(e);
                throw new Error(e);
            }
        };
        const _onCallback = dialog.$options?.methods?.onCallback;
        dialog.onCallback = function (arg) {
            try {
                let res = '';
                _onCallback && (res = _onCallback.call(dialog, arg));
                resolve(res);
                dialog.$destroy();
                _onClose && _onClose.call(dialog);
                document.body.removeChild(dialog.$el);
            }
            catch (e) {
                reject(e);
                throw new Error(e);
            }
        };
        dialog.$mount();
        dialog.$watch('visible', function () {
            dialog === false && dialog.onClose();
        });
        document.body.appendChild(dialog.$el);
    });
}
export { createDialog };
